export default defineNuxtPlugin({
  name: 'authorization-resolver',
  parallel: true,
  setup() {
    return {
      provide: {
        authorization: {
          resolveClientUser: () => {
            const { status, data } = useAuth()
            if (status.value === 'authenticated') return data.value?.user
            return null
          },
        },
      },
    }
  },
})